import * as React from 'react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ResizeSizeItem } from './types'
import InspectorSubheader from '@/scenes/Editor/components/Toolbox/InspectorSubheader'
import { ResizeSizeRow } from './ResizeSizeRow'
import { ShowMoreButton } from './ShowMoreButton'

interface ResizeCategoryProps {
  name: string
  items: ResizeSizeItem[]
  maxInitial?: number
  isActive: (item: ResizeSizeItem) => boolean
  onSelectItem: (item: ResizeSizeItem) => void
  renderPremiumBadge?: (item: ResizeSizeItem) => React.ReactNode
  renderExpandedContent?: (item: ResizeSizeItem) => React.ReactNode
  headerToggle?: boolean
  footerToggle?: 'none' | 'pill'
  className?: string
}

export function ResizeCategory({
  name,
  items,
  maxInitial = 4,
  isActive,
  onSelectItem,
  renderPremiumBadge,
  renderExpandedContent,
  headerToggle = true,
  footerToggle = 'none',
  className,
}: ResizeCategoryProps) {
  const { t } = useTranslation()
  const [expanded, setExpanded] = useState(false)
  const [hovered, setHovered] = useState(false)

  const hasMore = items.length > maxInitial
  const visible = expanded ? items : items.slice(0, maxInitial)

  return (
    <div
      className={className}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {name && (
        <div
          style={{
            height: '26px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: '8px',
          }}
        >
          <InspectorSubheader label={t(name)} capitalize />
          {hasMore && headerToggle && (
            <ShowMoreButton
              variant="text"
              expanded={expanded}
              onToggle={() => setExpanded((v) => !v)}
            />
          )}
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {visible.map((item) => (
          <ResizeSizeRow
            key={String(item.id)}
            item={item}
            name={item.name}
            active={isActive(item)}
            onClick={() => onSelectItem(item)}
            premiumBadge={renderPremiumBadge ? renderPremiumBadge(item) : undefined}
            expandedContent={renderExpandedContent ? renderExpandedContent(item) : undefined}
          />
        ))}
      </div>

      {hasMore && footerToggle === 'pill' && (
        <ShowMoreButton
          variant="pill"
          expanded={expanded}
          onToggle={() => setExpanded((v) => !v)}
          active={hovered}
        />
      )}
    </div>
  )
}
